import 'whatwg-fetch'
import config from '../../../config/config'

export const ARC_XP_URLS = {
	getStory: '/{type}/{store}/{id}/'
}

export class ArcxpAjaxRequest {
  static setStore(store) {
    this._store = store
  }

  static getStore() {
    return this._store
  }

  static replaceParam(url, param, value){
    return url.replace(new RegExp(`{${param}}`, 'g'), value)
  } 

  static getUrl(rawUrl, args) {
    let url = this.replaceParam(rawUrl, 'store', this._store)
    Object.keys(args).forEach((key) => {
      url=this.replaceParam(url, key, args[key])
    })
    return url
  }

  static get(rawUrl, args) {
    const url = `${config.arcxp_base_url}${this.getUrl(rawUrl, args)}`
    return fetch(url, {
      method: 'GET'
    }).then((res) => (
      res.json()
    )).catch(e => console.log(e))
  }
}



// WEBPACK FOOTER //
// ./src/utils/business/arcxprequest.js